import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useState } from "react";
import CardSeplag from "../../../components/CardSeplag";
import RotuloSeplag from "../../../components/RotuloSeplag";
import {
  detailAlteracaoSucessoPadrao,
  detailCriacaoSucessoPadrao,
  printToast,
  summaryAlteracaoSucessoPadrao,
  summaryCriacaoSucessoPadrao,
  summaryExclusaoSucessoPadrao,
} from "../../../config/global";
import {
  downloadArquivoAndamento,
  excluir,
  initFormAndamento,
  salvar,
} from "../../../service/Monitora/Lancamentos/andamentos";
import "./style.css";

const Andamentos = ({ ptaMonitora, setFormPta, isPodeEditar, isPodeVisualizar }) => {
  const [form, setForm] = useState(initFormAndamento);
  const [qtdMaxCaracteres] = useState(2000);
  const [countCaracteres, setCountCaracteres] = useState(0);
  const [andamentos, setAndamentos] = useState(ptaMonitora.andamentos.filter((e) => e.statAndamento == 1));
  const [isVisualizar, setIsVisualizar] = useState(false);
  const [arquivo, setArquivo] = useState("");
  const [atualizaArquivo, setAtualizaArquivo] = useState(false);

  useEffect(() => {
    contarCaracteres();
  }, [form]);

  const isValidDate = (dateString) => {
    const [day, month, year] = dateString.split("/").map(Number);
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  };

  const salvarAndamento = () => {
    form.ptaMonitora = ptaMonitora;
    let jsonPost = {
      ...form,
    };

    if (!isValidDate(jsonPost.dataAndamento) || jsonPost.descAndamento.trim() === "") {
      return printToast({ severity: "error", detail: "Data inválida ou campo de descrição vazio" });
    }

    let formData = new FormData();

    formData.append("idenPtaMonitora", jsonPost.ptaMonitora.idenPtaMonitora);
    formData.append("dataAndamento", jsonPost.dataAndamento);
    formData.append("descAndamento", jsonPost.descAndamento);
    formData.append("ptaMonitora", jsonPost.ptaMonitora);
    formData.append("statAndamento", 1);
    formData.append("file", arquivo || null);
    formData.append("atualizaArquivo", atualizaArquivo);
    formData.append("idenAndamento", jsonPost?.idenAndamento || 0);

    let summary = form.idenAndamento > 0 ? summaryAlteracaoSucessoPadrao : summaryCriacaoSucessoPadrao;
    let detail = form.idenAndamento > 0 ? detailAlteracaoSucessoPadrao : detailCriacaoSucessoPadrao;

    salvar(formData).then((res) => {
      let andamento = andamentos.filter((item) => item.idenAndamento != res.idenAndamento);
      setAndamentos([...andamento, res]);

      setForm(initFormAndamento);
      setFormPta({ ...ptaMonitora, andamentos: [...andamento, res] });
      setArquivo();
      printToast({ summary, detail });
    });

    setAtualizaArquivo(false);
  };

  function visualizarAndamento(rowData) {
    setIsVisualizar(true);
    setForm(rowData);
  }

  function editarAndamento(rowData) {
    setArquivo(rowData.arquivoMonitora);
    setIsVisualizar(false);
    setForm(rowData);
  }

  function excluirAndamento(rowData) {
    excluir(rowData.idenAndamento).then((res) => {
      let andamentosExc = andamentos.filter((item) => item.idenAndamento != rowData.idenAndamento);
      setAndamentos(andamentosExc);
      setFormPta({ ...ptaMonitora, andamentos: andamentosExc });
      printToast({ summaryExclusaoSucessoPadrao, detail: "O registro foi excluído com sucesso" });
    });
  }

  const rejectFunc = () => {};

  const confirmaExclusao = (rowData) => {
    confirmDialog({
      message: "Deseja excluir este andamento?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => excluirAndamento(rowData),
      reject: () => rejectFunc(),
    });
  };

  const acoesTemplate = (node, column) => {
    return (
      <>
        {isPodeVisualizar && (
          <Button
            type="button"
            icon="pi pi-eye"
            className="p-button-primary Raised"
            onClick={() => visualizarAndamento(node)}
          ></Button>
        )}
        <Button
          type="button"
          icon="pi pi-pencil"
          style={{ marginLeft: "5px" }}
          className="p-button-warning Raised"
          onClick={() => editarAndamento(node)}
        ></Button>
        <Button
          type="button"
          icon="pi pi-trash"
          style={{ marginLeft: "5px" }}
          className="p-button-danger Raised"
          onClick={() => confirmaExclusao(node)}
          disabled={!isPodeEditar || !ptaMonitora.permiteAndamento}
        ></Button>
      </>
    );
  };

  function contarCaracteres() {
    setCountCaracteres(form.descAndamento != null ? qtdMaxCaracteres - form.descAndamento.length : 2000);
  }

  const onUpload = (e) => {
    setAtualizaArquivo(true);
    setArquivo(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
    }
  };

  const downloadAndamento = (rowData) => {
    downloadArquivoAndamento(rowData.arquivoMonitora.idenArquivo).then((res) => {
      const base64Data = res.data.split(",")[1];

      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // a.download = `${rowData.arquivoMonitora.descArquivo}.pdf`;
      a.download = rowData.arquivoMonitora.descArquivo;
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  return (
    <>
      <CardSeplag title="Análise de Andamento">
        <div className="p-fluid grid">
          <div className="field col-12 md:col-3 ">
            <span>
              <label htmlFor="dataandamento">Data</label>
              <InputMask
                mask="99/99/9999"
                slotChar="__/__/____"
                placeholder="__/__/____"
                id="dataandamento"
                value={form.dataAndamento}
                onChange={(e) => setForm({ ...form, dataAndamento: e.target.value })}
                disabled={!isPodeEditar || !ptaMonitora.permiteAndamento || isVisualizar}
              />
            </span>
          </div>
          <div className="field col-12 md:col-9 ">&nbsp;</div>
          <div className="field col-12 md:col-12 ">
            <span>
              <label htmlFor="descandamento">Descrição</label>
              <InputTextarea
                id="descandamento"
                maxLength={2000}
                rows={5}
                cols={30}
                value={form.descAndamento}
                onKeyUp={(e) => setCountCaracteres(qtdMaxCaracteres - e.target.value.length)}
                onChange={(e) => setForm({ ...form, descAndamento: e.target.value })}
                disabled={!isPodeEditar || !ptaMonitora.permiteAndamento || isVisualizar}
              />
            </span>
          </div>
          <div className="field col-12 md:col-12 ">
            <span>
              <b>{countCaracteres}</b> caractere(s) restante(s)
            </span>
          </div>
        </div>
      </CardSeplag>
      {!isVisualizar && (
        <>
          <RotuloSeplag cols="12 4 4">
            <label
              htmlFor="selecao-arquivo"
              className="label"
              disabled={!isPodeEditar || !ptaMonitora.permiteAndamento}
            >
              Selecionar um arquivo &#187;
            </label>
            <input
              id="selecao-arquivo"
              type="file"
              onChange={onUpload}
              accept="application/pdf"
              disabled={!isPodeEditar || !ptaMonitora.permiteAndamento}
            />
          </RotuloSeplag>

          <div className="" style={{ paddingTop: "1rem" }}>
            {arquivo && (
              <RotuloSeplag nome="Nome do arquivo adicionado">
                <InputText value={arquivo.name || arquivo.descArquivo} disabled />
              </RotuloSeplag>
            )}
          </div>
          <div className="p-fluid grid">
            <div className="field col-12 md:col-9 ">&nbsp;</div>
            <div className="field col-12 md:col-3 ">
              <br></br>
              <Button
                label="Salvar"
                icon={"pi pi-check"}
                autoFocus
                disabled={!isPodeEditar || !ptaMonitora.permiteAndamento}
                className="p-button-success"
                onClick={salvarAndamento}
              />
            </div>
          </div>
          <ConfirmDialog />
        </>
      )}
      <CardSeplag title="Análises de Andamento cadastradas">
        <DataTable emptyMessage="Não foram encontradas análises de andamento para este item" value={andamentos}>
          <Column
            body={acoesTemplate}
            style={{ textAlign: "center", width: "18%" }}
            field="idenAndamento"
            header="Ações"
          ></Column>
          <Column field="dataAndamento" header="Data"></Column>
          <Column field="descAndamento" header="Descrição do Andamento"></Column>
          <Column
            field="arquivoMonitora.descArquivo"
            header="Descrição do Arquivo"
            body={(rowData) =>
              rowData.arquivoMonitora && rowData.arquivoMonitora.descArquivo ? (
                <Button
                  icon="pi pi-download"
                  label={rowData.arquivoMonitora.descArquivo}
                  className="p-button-text"
                  iconPos="right"
                  onClick={() => downloadAndamento(rowData)}
                />
              ) : (
                "Nenhum arquivo"
              )
            }
          ></Column>
        </DataTable>
      </CardSeplag>
    </>
  );
};

export default Andamentos;
